import { useLogging } from '@/hooks/useLogging';
import { useVersionUpdateNotification } from '@/hooks/useVersionUpdateNotification';

const AppServices = () => {
  useLogging();
  useVersionUpdateNotification();

  return null;
};

export default AppServices;
